import type { SegmentDTO } from '@next-space/fe-api-idl';
import { buildDateSegment } from 'src/editor/utils/segments';
import { getViewFormat } from 'src/hooks/block/get-view-format';
import { moveBlock } from 'src/redux/managers/block/move';
import { updateBlock } from 'src/redux/managers/block/update';
import { cache, getState } from 'src/redux/store';
import { getDropInfo } from 'src/services/app/hook/use-drop-info';
import { fixCollectionId } from 'src/utils/fix-collection-id';
import { selectedBlocksToIds } from './select-block-util';

export const moveToCalendar = () => {
  const { ui } = cache;
  const { viewId, calendarDate, tocInfo, dropId, position } = getDropInfo() ?? {};
  if (!viewId || !calendarDate) return;

  const collectionId = fixCollectionId(viewId);
  if (!collectionId) return;

  const { calendarBy, calendarByEnd } = getViewFormat(viewId) ?? {};
  if (!calendarBy && !calendarByEnd) return;

  const ids = tocInfo?.dragToc ? [tocInfo.dragToc] : selectedBlocksToIds(ui.selectedBlocks);
  if (dropId && cache.blocks[collectionId]?.subNodes.includes(dropId)) {
    if (position === 'top') {
      moveBlock(ids, { parentId: collectionId, before: dropId }, viewId);
    } else {
      moveBlock(ids, { parentId: collectionId, after: dropId }, viewId);
    }
  } else {
    moveBlock(ids, { parentId: collectionId, last: true }, viewId);
  }

  const propertyValues: Record<string, SegmentDTO[]> = {};
  if (calendarBy) {
    propertyValues[calendarBy] = [buildDateSegment({ from: new Date(calendarDate) })];
  }
  if (calendarByEnd) {
    propertyValues[calendarByEnd] = [buildDateSegment({ from: new Date(calendarDate) })];
  }

  const { blocks } = getState();
  ids.forEach((uuid) => {
    const block = blocks[uuid];
    if (!block) return;
    updateBlock(uuid, {
      data: {
        collectionProperties: {
          ...block.data.collectionProperties,
          ...propertyValues,
        },
      },
    });
  });
};
